// document.addEventListener("DOMContentLoaded", (e) => {
$(document).ready(function(){

    document.querySelectorAll('.shopify-section').forEach(function(section) {
        if (section.querySelector('.sticky-header.header')) {
          section.classList.add('has-sticky-header');
        }
    });

    /* Logo Carousel */

    let logoSlider = $('.js-logo-carousel');
    function initLogoSlider() {
        if ($(window).width() <= 991 && logoSlider.length > 0) {
            logoSlider.each(function () {
                let currentLogoSlider = $(this);
                if (!currentLogoSlider.hasClass('slick-initialized')) {
                    currentLogoSlider.slick({
                        speed: 5000, 
                        autoplay: true,
                        arrows: false,
                        cssEase: 'linear',
                        autoplaySpeed: 0,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        swipeToSlide: false,
                        infinite: true, 
                        variableWidth: true,
                    });
                }
            });
        }
    }
 
    initLogoSlider();
    $(window).on('resize',function(){
        initLogoSlider();
    });
    /* Logo Carousel */

   

    $(".faq-question").on("click", function () {
        const parent = $(this).closest(".faq-item");
        const answer = parent.find(".faq-answer");
        const isActive = parent.hasClass("active");
  
        $(".faq-answer").not(answer).slideUp(500);
        $(".faq-item").not(parent).removeClass("active");
  
        if (isActive) {
            answer.slideUp(500);
            parent.removeClass("active");
        } else {            
            answer.slideDown(500); 
            parent.addClass("active");
        }
    });

    handleFeaturedSlider(); 

    /* Header Js */
    let hamburgerIcon = $('.js-hamburger-icon');
    let closeIcon = $('.js-close-icon');
    let headerMenu = $('.js-header-menu');
    let body = $('body');
    let headerMenuLink = $('.header__menu-item .header__menu-link');
    let headerSubMenuLink = $('.submenu__heading .submenu__heading-link');
    let subMenuPrevButton= $('.header__submenu > .js-previous-button');
    let childSubMenuPrevButton= $('.submenu__list > .js-previous-button')

   

        hamburgerIcon?.on('click', function(event){
             if (window.innerWidth < 992) {
                event.preventDefault();

                if ($('.header__search-wrapper').hasClass('is-searchbox-active') && body.hasClass('is-searchbox-active')) {
                    $('.js-close-search').trigger('click');
                }
                checkHeaderOffset();

                let currentElem = event.currentTarget;
                if(!headerMenu.hasClass('is-active-menu') && !body.hasClass('is-active-menu')){
                    headerMenu.addClass('is-active-menu');
                    body.addClass('is-active-menu is-overlay-active is-hidden');
                }

                if($(currentElem).parent().hasClass('header__menu-icon') && !$(currentElem).parent().hasClass('show-close-icon')){
                    $(currentElem).parent().addClass('show-close-icon');
                }
            }
        });

        closeIcon?.on('click', function(event){
            event.preventDefault();
            let currentElem = event.currentTarget;
            if(headerMenu.hasClass('is-active-menu') && body.hasClass('is-active-menu')){
                headerMenu.removeClass('is-active-menu');
                body.removeClass('is-active-menu is-overlay-active is-hidden');
            }

            if($(currentElem).parent().hasClass('header__menu-icon') && $(currentElem).parent().hasClass('show-close-icon')){
                $(currentElem).parent().removeClass('show-close-icon');
            }
        });

        headerMenuLink?.on('click', function(event){
            event.preventDefault();
            let currentElem = event.currentTarget;
            let parentElem = $(currentElem).parent();

            if((parentElem.hasClass('is-mega-menu') && !parentElem.hasClass('is-open-submenu')) && !$(currentElem).next().hasClass('submenu__shop')){
                if(parentElem.siblings('.header__menu-item').hasClass('is-open-submenu')){
                    parentElem.siblings('.header__menu-item').removeClass('is-open-submenu')
                }

                if(!parentElem.hasClass('is-open-submenu')){
                    parentElem.addClass('is-open-submenu');
                }

            } 
        });

        subMenuPrevButton?.on('click', function(event){
            event.preventDefault();
            let currentElem = event.currentTarget;

            if(subMenuPrevButton.parent().hasClass('header__submenu') && subMenuPrevButton.parents('.header__menu-item').hasClass('is-open-submenu')) {
                subMenuPrevButton.parents('.header__menu-item').removeClass('is-open-submenu');
            }
        });

        headerSubMenuLink?.on('click', function(event){
            event.preventDefault();
            let currentElem = event.currentTarget;
            let parentElemCol = $(currentElem).parents('.submenu__menu-col');

            if((parentElemCol && !parentElemCol.hasClass('is-open-child-submenu')) && $(currentElem).parent().next().hasClass('submenu__list')){
                if(parentElemCol.siblings('.submenu__menu-col').hasClass('is-open-child-submenu')){
                    parentElemCol.siblings('.submenu__menu-col').removeClass('is-open-child-submenu')
                }

                if(!parentElemCol.hasClass('is-open-child-submenu')){
                    parentElemCol.addClass('is-open-child-submenu');
                }

            }
        });

        childSubMenuPrevButton?.on('click', function(event){
            event.preventDefault();
            let currentElem = event.currentTarget;

            if(childSubMenuPrevButton.parents('.submenu__menu-col') && childSubMenuPrevButton.parents('.submenu__menu-col').hasClass('is-open-child-submenu')) {
                childSubMenuPrevButton.parents('.submenu__menu-col').removeClass('is-open-child-submenu');
            }
        });

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.header, .announcement-bar , .js-close-icon').length > 0 ) {
                if (headerMenu.hasClass('is-active-menu') && body.hasClass('is-active-menu')) {
                    headerMenu.removeClass('is-active-menu');
                    body.removeClass('is-active-menu is-overlay-active is-hidden');
                }
        
                if($('.header__menu-item.is-open-submenu').length > 0) {
                    $('.header__menu-item.is-open-submenu').removeClass('is-open-submenu');
                }

                if($('.submenu__menu-col.is-open-child-submenu').length > 0) {
                    $('.submenu__menu-col.is-open-child-submenu').removeClass('is-open-child-submenu');
                }
        
                if($('.header__menu-icon.show-close-icon').length > 0) {
                    $('.header__menu-icon.show-close-icon').removeClass('show-close-icon');
                }
            }
        });
    /* Header Js */

    /* Search Box */
    let searchIcon = $('.js-header-search');
    let closeSearchIcon = $('.js-close-search');

    searchIcon.on('click', function(event) {
        event.preventDefault();

        let currentElem = event.currentTarget;
        let nextElemSearchWarp = $(currentElem).next('.header__search-wrapper')
        
        if (headerMenu.hasClass('is-active-menu') && body.hasClass('is-active-menu')) {
            closeIcon.trigger('click');
        }

        if(nextElemSearchWarp && !nextElemSearchWarp.hasClass('is-searchbox-active') && !body.hasClass('is-searchbox-active')){
            nextElemSearchWarp.addClass('is-searchbox-active');
            body.addClass('is-searchbox-active is-overlay-active is-hidden')
        }

        checkSearchBox();

    });

    closeSearchIcon.on('click', function(event) {
        event.preventDefault()

        let currentElem = event.currentTarget;
        let searchWarpper = $(currentElem).parents('.header__search-wrapper');

        if((searchWarpper.length > 0 && searchWarpper.hasClass('is-searchbox-active')) && body.hasClass('is-searchbox-active')){
            searchWarpper.removeClass('is-searchbox-active');
            body.removeClass('is-searchbox-active is-overlay-active is-hidden');
        }
    });

    $(document).on('click', function(event) {
        if ( !$(event.target).closest('.header, .announcement-bar , .js-header-search, .header__search-wrapper').length > 0) {
            let activeSearchWrapper = $('.header__search-wrapper.is-searchbox-active');
    
            if (activeSearchWrapper.length && body.hasClass('is-searchbox-active')) {
                activeSearchWrapper.removeClass('is-searchbox-active');
                body.removeClass('is-searchbox-active is-overlay-active is-hidden');
            }
        }
    });

    let cartBestProductSlider = $('.js-cart-best-product-slider');

    cartBestProductSlider.each(function () {
        let currentCartBestProductSlider = $(this);

        if (!currentCartBestProductSlider.hasClass('slick-initialized')) {
            let sliderWrap = currentCartBestProductSlider.closest('.eq-cart__product');
            let arrowsWrap = sliderWrap.find('.js-cart-arrow');
    
            // Move arrows into header-right if needed
            if (arrowsWrap.length > 0) {
                sliderWrap.find('.eq-cart__product-header-right').append(arrowsWrap);
            }
    
            currentCartBestProductSlider.slick({
                arrows: false,
                infinite: false,
                slidesToShow: parseFloat($(currentCartBestProductSlider).attr('data-slide-desktop'), 10),
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: parseFloat($(currentCartBestProductSlider).attr('data-slide-tab'), 10),
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: parseFloat($(currentCartBestProductSlider).attr('data-slide-mobile'), 10),
                        }
                    }
                ]
            });
    
            let $prevArrow = sliderWrap.find('.js-cart-prev-arrow');
            let $nextArrow = sliderWrap.find('.js-cart-next-arrow');
    
            if ($prevArrow.length > 0) {
                $prevArrow.on('click', function () {
                    currentCartBestProductSlider.slick('slickPrev');
                    updateCartArrowState(currentCartBestProductSlider);
                });
            }
    
            if ($nextArrow.length > 0) {
                $nextArrow.on('click', function () {
                    currentCartBestProductSlider.slick('slickNext');
                    updateCartArrowState(currentCartBestProductSlider);
                });
            }
    
            currentCartBestProductSlider.on('afterChange', function () {
                updateCartArrowState(currentCartBestProductSlider);
            });
    
            updateCartArrowState(currentCartBestProductSlider);
        }
    });

    /* Cart Best Product Slider */

    /* Header Search active tab */
    $(document).on("click", ".buttons_wrp_predictive button", (event) => {
        let currentTarget = event.currentTarget;
        let targetId = $(currentTarget).attr("data-id");

        if($(currentTarget).siblings('button').hasClass('is-button-active')){
            $(currentTarget).siblings('button').removeClass("is-button-active");
        }
        $(currentTarget).addClass("is-button-active");

        if($(document).find(".results_wrp_predictive .predictive-search__resource-item").hasClass(('is-tab-active'))){
            $(document).find(".results_wrp_predictive .predictive-search__resource-item").removeClass('is-tab-active');
        }

        let activeTab = $("#" + targetId);
        if (activeTab && activeTab.length > 0) {
            activeTab.addClass("is-tab-active");
        }
    });
    /* Header Search active tab */

    $('body').on('click', '.header__action-icon .header__cart', function(event) {
        event.preventDefault();

        if ($('.js-header-menu').hasClass('is-active-menu') && $('body').hasClass('is-active-menu')) {
            $('.js-close-icon').trigger('click'); // Update as needed
        }
        if ($('.header__search-wrapper').hasClass('is-searchbox-active') && $('body').hasClass('is-searchbox-active')) {
            $('.js-close-search').trigger('click');
        }

        const cartDrawer = $('.eq-cart-drawer');
        if (!cartDrawer.hasClass('is-cart-drawer-open') && !$('body').hasClass('is-cart-drawer-open')) {
            cartDrawer.addClass('is-cart-drawer-open');
            $('body').addClass('is-cart-drawer-open is-hidden');
        }
    });

    $('body').on('click', '.js-cart-drawer-close', function(event) {
        event.preventDefault();

        const cartDrawer = $(this).closest('.eq-cart-drawer');
        if (cartDrawer.hasClass('is-cart-drawer-open') && $('body').hasClass('is-cart-drawer-open')) {
            cartDrawer.removeClass('is-cart-drawer-open');
            $('body').removeClass('is-cart-drawer-open is-hidden');
        }
    });

    $('body').on('click', function(event) {
    const $target = $(event.target);
    const $cartDrawer = $('.eq-cart-drawer');

    if (
        $cartDrawer.hasClass('is-cart-drawer-open') &&
        !$target.closest('.eq-cart-drawer').length &&
        !$target.closest('.header__action-icon .header__cart').length
    ) {
        $cartDrawer.removeClass('is-cart-drawer-open');
        $('body').removeClass('is-cart-drawer-open is-hidden');
    }
});


    
});

function updateCartArrowState(slider) {
    console.log("updateCartArrowState :");
    
    let currentSlide = $(slider).slick('slickCurrentSlide');
    let slideCount = $(slider).slick('getSlick').slideCount;
    let slidesToShow = $(slider).slick('slickGetOption', 'slidesToShow');
    let parent = slider.parents('.eq-cart__product');
    let prevArrow = parent.find('.js-cart-prev-arrow');
    let nextArrow = parent.find('.js-cart-next-arrow');

    if (slideCount <= slidesToShow && !$(slider).parents('.eq-cart__product').find('.js-cart-arrow').hasClass('is-custom-arrows-hidden')) {
        $(slider).parents('.eq-cart__product').find('.js-cart-arrow').addClass('is-custom-arrows-hidden')
        return;
    } else {
        if($(slider).parents('.eq-cart__product').find('.js-cart-arrow').hasClass('is-custom-arrows-hidden')){
            $(slider).parents('.eq-cart__product').find('.js-cart-arrow').removeClass('is-custom-arrows-hidden')
        }
    }

    if (currentSlide === 0) {
        prevArrow.addClass('slick-disabled');
    } else {
        prevArrow.removeClass('slick-disabled');
    }

    if (currentSlide >= slideCount - slidesToShow) {
        nextArrow.addClass('slick-disabled');
    } else {
        nextArrow.removeClass('slick-disabled');
    }
}

function checkSearchBox() {
    let searchBox = $('.header__search-wrapper');
    if(searchBox && searchBox.length > 0){
        if(searchBox.hasClass('is-searchbox-active')){
            checkHeaderOffset();
        }
    }
}

function getVisibleHeight(el) {
    let rect = el.getBoundingClientRect();
    let windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    let visibleTop = Math.max(rect.top, 0);
    let visibleBottom = Math.min(rect.bottom, windowHeight);

    let visibleHeight = visibleBottom - visibleTop;

    return Math.max(0, visibleHeight); 
}

function checkHeaderOffset() {
    let header = $('.header');
    let announcementBar = $('.announcement-bar');
    let totalOffset = 0;

    if (header.length && header.is(':visible')) {
        totalOffset += header.outerHeight();
    }
    if (announcementBar.length && announcementBar.is(':visible') ) {
        totalOffset += getVisibleHeight(announcementBar[0]);
    }
    document.documentElement.style.setProperty('--header-offset', `${totalOffset}px`);
    
}

checkHeaderOffset();


$(window).on('load resize', function() {
    if (window.innerWidth < 992) {
        checkHeaderOffset();
    }
});

$(window).scroll(function() {
    checkHeaderOffset();
});


function handleFeaturedSlider() {
    var $slider = $(".js-featured_coll_pdp_slider");

    if ($slider.length > 0) {
        if ($(window).width() < 992) {
            if (!$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    arrows: false,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1.3
                            }
                        }
                    ]
                });
            }
        } else {
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
        }
    }
}

$(window).on('resize', function () {
    handleFeaturedSlider();
});

function bestProductMatchHeightElement(slider) {
      if ($(slider).find('.product-box .product-box__detail_top').length > 0) {
        $(slider).find('.product-box .product-box__detail_top').matchHeight({
          byRow: true,
        });
    }
}

function productMatchHeightElement() {
    if ($('.best-product-tabbing .product-box .product-box__detail_top').length > 0) {
        $('.best-product-tabbing .product-box .product-box__detail_top').matchHeight({
          byRow: true,
        });
    }
}

     
if ($('.eq_product_grid .eq_product_item_coll .product-box__detail_top').length > 0) {
        $('.eq_product_grid .eq_product_item_coll .product-box__detail_top').matchHeight({
          byRow: true,
        });
    }

if ($('.eq_article_card .aricle_title').length > 0) {
        $('.eq_article_card .aricle_title').matchHeight({
          byRow: true,
        });
    }
   



window.addEventListener("load", function () {

    let productTabbing = document.querySelectorAll('.product-tabbing')
    productTabbing.forEach(function (tabBox) {
    
        let firstTab = tabBox.querySelector('.js-product-tabbing li:first-child');
        if (firstTab) {
            firstTab.click();
        }
    });
    

    // Trigger first Best product dropdown option click on window load
    let firstOption = $('.js-dropdown-select').find('.dropdown-option').first();
    if (firstOption) {
        firstOption.trigger('click');
    }

    /* Product card match height */

      if ($('.product-card .product-box .product-box__detail_top').length > 0) {
        $('.product-card .product-box .product-box__detail_top').matchHeight({
          byRow: true,
        });
    }

    /* Product card match height */

    function product_card_images_slider(){
        if (document.querySelectorAll('.js-product-images-slider').length > 0) {
                document.querySelectorAll('.js-product-images-slider').forEach(function (slider) {
                $(slider).css({'--width': $(slider).closest('.product-box').width()+'px','--height': $(slider).closest('.product-box').height()});
                if(!$(slider).hasClass('slick-initialized')) {
                    $(slider).slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        prevArrow: $(slider).closest('.product-box__image_wrp').find('.js-custom-prev-arrow'),
                        nextArrow: $(slider).closest('.product-box__image_wrp').find('.js-custom-next-arrow'),
                        initialSlide: 0, 
                        infinite: false,
                        variableWidth: true
                    });
                } else {
                    // $(slider).slick('refresh');
                      $slider.slick('setPosition');
                }
            });
        }
    }
    product_card_images_slider();
    // $(window).on('resize', function() {
    //   product_card_images_slider();
    // });


    if($(window).width() < 750) {
        $('body').on("click",".open_mobile_facets_filter",function(e){
            e.preventDefault();
            $('.facets_filters_wrp').toggleClass("show");
            $('body').toggleClass("show_filter");
        });
      document.addEventListener('click', function(event) {
        var popup = document.querySelector('.facets_filters_wrp');
        var toggleBtn = document.querySelector('.open_mobile_facets_filter');
      
        if (
          popup && 
          popup.classList.contains('show') &&
          !popup.contains(event.target) &&
          !toggleBtn.contains(event.target)
        ) {
          popup.classList.remove('show');
          $('body').toggleClass("show_filter");
        }
      });

    }


    $('body').on('click',".faq_tab",function () {
      $('.faq_tab').removeClass('is-tab-active');
      $(this).addClass('is-tab-active');
      
      var tabId = $(this).attr('id');
      $('.faq_group').removeClass("show_active");
      $('[data-id="' + tabId + '"]').addClass("show_active");
    });

function time_cal(){
      const spans = document.querySelectorAll('.how_much_time');
  
        spans.forEach(async span => {
            const url = span.dataset.url;
            if (!url) return;

            try {
            const res = await fetch(url);
            const html = await res.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

                console.log("sss");
            const article = doc.querySelector('article');
            if (!article) {
                span.textContent = "Read time N/A";
                return;
            }

            const text = article.innerText || "";
            const wordCount = text.trim().split(/\s+/).length;
            const readingTime = Math.max(1, Math.ceil(wordCount / 200)); // Minimum 1 min

            span.textContent = `${readingTime} min read`;
            } catch (err) {
            console.error("Reading time error:", err);
            span.textContent = "Read time N/A";
            }
        });
    }

    if($('.how_much_time').length > 0) {
        time_cal();
    }


    $('body').on('click',"[data-loadmore_btn]", function(e) {
        e.preventDefault();

        var $btn = $(this);
        var nextUrl = $btn.data('next');

        if (!nextUrl) return;

        $.get(nextUrl, function(data) {
        var newArticles = $(data).find('.eq_blogs_list').html();
        $('.eq_blogs_list').first().append(newArticles);

        if ($('.eq_article_card .aricle_title').length > 0) {
            $('.eq_article_card .aricle_title').matchHeight({
            byRow: true,
            });
        }
        time_cal();
   

        var newNext = $(data).find('[data-loadmore_btn]').data('next');
        if (newNext) {
            $btn.data('next', newNext);
        } else {
            $btn.remove(); 
        }
        });
  });


  let leftHeaderSearch = $('.js-header-search-left');

        leftHeaderSearch.on('click', function (event) {
            event.preventDefault();

            let currentElem = event.currentTarget;
            console.log("currentElem : ", currentElem);

            if($('.header__right .header__search').length > 0 && $('.header__right .header__search-wrapper').length > 0) {
                console.log('Length Search : ', $('.header__right .header__search'));
                console.log('Length Search Warpper : ', $('.header__right .header__search-wrapper'));

                $('.js-header-search').trigger('click');
            }
        });


});

// Product card slider start
const swiper = new Swiper('.product-swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


// product card slider end

/* Best Product Dropdown Filter slider */

document.addEventListener('DOMContentLoaded', function () {
    const swiperInstances = {};

    // 1. Initialize Swipers for all sliders
    document.querySelectorAll('.js-filter-slider').forEach(slider => {
        const filterId = slider.dataset.filter;

        swiperInstances[filterId] = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: true,
        navigation: {
            nextEl: '.js-custom-next-arrow',
            prevEl: '.js-custom-prev-arrow',
        }
        });

        // Optional: run matchHeight initially
        bestProductMatchHeightElement(slider);
    });

    // 2. Set first slider active by default
    const allSliders = document.querySelectorAll('.js-filter-slider');
    if (allSliders.length > 0) {
        allSliders.forEach(slider => slider.classList.remove('active'));
        allSliders[0].classList.add('active');
        setTimeout(() => {
        bestProductMatchHeightElement(allSliders[0]);
        }, 50);
    }

    // 3. Dropdown logic
    const dropdown = document.querySelector('.js-dropdown-select');
    const selectedText = dropdown.querySelector('.js-selected-option .dropdown-selected-option-text');
    const dropdownOptions = dropdown.querySelector('.dropdown-options');

    // Open dropdown on click
    dropdown.querySelector('.js-selected-option').addEventListener('click', function (e) {
        e.stopPropagation();
        dropdownOptions.classList.toggle('active');
    });

    // Handle dropdown selection
    document.querySelectorAll('.dropdown-option').forEach(option => {
        option.addEventListener('click', function () {
        const selectedId = this.dataset.id;
        const selectedLabel = this.dataset.text;

        selectedText.innerHTML = selectedLabel;
        dropdownOptions.classList.remove('active');

        // Hide all sliders
        allSliders.forEach(slider => slider.classList.remove('active'));

        // Show the selected one
        const targetSlider = document.querySelector(`.js-filter-slider[data-filter="${selectedId}"]`);
        if (targetSlider) {
            targetSlider.classList.add('active');

            // Update Swiper
            swiperInstances[selectedId].update();

            // Delay matchHeight to allow DOM to settle
            setTimeout(() => {
            bestProductMatchHeightElement(targetSlider);
            }, 50);
        }
        });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
        dropdownOptions.classList.remove('active');
        }
    });

    // 4. Match height function
    function bestProductMatchHeightElement(slider) {
        const $targets = $(slider).find('.product-box .product-box__detail_top');
        if ($targets.length > 0) {
        $targets.matchHeight({ byRow: true });
        }
    }
    });

/* Best Product Dropdown Filter slider */


/* Hero Carousel */
document.addEventListener('DOMContentLoaded', function () {
  let isAutoplayRunning = true;

  const heroDetailsSwiper = new Swiper('.hero-details-swiper', {
    loop: true,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    allowTouchMove: false
  });

  const heroImageSwiper = new Swiper('.hero-image-swiper', {
    loop: true,
    navigation: {
      nextEl: '.js-hero-next-arrow',
      prevEl: '.js-hero-prev-arrow'
    },
    pagination: {
      el: '.js-hero-pagination',
      type: 'fraction'
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    },
    thumbs: {
      swiper: heroDetailsSwiper
    },
    on: {
      init: function () {
        // Set up hover pause
        ['.hero-image-swiper', '.hero-details-swiper'].forEach(selector => {
          const el = document.querySelector(selector);
          if (el) {
            el.addEventListener('mouseenter', () => {
              if (isAutoplayRunning) heroImageSwiper.autoplay.stop();
            });
            el.addEventListener('mouseleave', () => {
              if (isAutoplayRunning) heroImageSwiper.autoplay.start();
            });
          }
        });

        // Set up play/pause buttons
        const pauseBtn = document.getElementById('pauseBtn');
        const playBtn = document.getElementById('playBtn');

        pauseBtn?.addEventListener('click', () => {
          heroImageSwiper.autoplay.stop();
          isAutoplayRunning = false;
          pauseBtn.style.display = 'none';
          playBtn.style.display = 'inline-block';
        });

        playBtn?.addEventListener('click', () => {
          heroImageSwiper.autoplay.start();
          isAutoplayRunning = true;
          playBtn.style.display = 'none';
          pauseBtn.style.display = 'inline-block';
        });
      }
    }
  });
});
/* Hero Carousel */

/* Start home page product benefits swiper */
let productTabbing_benifits = document.querySelectorAll('.product-tabbing.benefites_slider_tabbing');

productTabbing_benifits.forEach(function (tabBox) {
  let slider = tabBox.querySelector('.js-tab-slider');

  slider.classList.add('swiper');

  const tabItems = tabBox.querySelectorAll('.product-tabbing__item');
  const originalSlides = slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');

  const swiperInstance = new Swiper(slider, {
    slidesPerView: parseFloat(slider.getAttribute('data-slide-desktop')),
    spaceBetween: 0,
    loop: true,
    draggable: true,
    touchMove: true,
    allowTouchMove: true,
    navigation: {
      prevEl: tabBox.querySelector('.js-custom-prev-arrow'),
      nextEl: tabBox.querySelector('.js-custom-next-arrow'),
    },
    breakpoints: {
      0: {
        slidesPerView: parseFloat(slider.getAttribute('data-slide-mobile')),
      },
      768: {
        slidesPerView: parseFloat(slider.getAttribute('data-slide-tab')),
      },
      992: {
        slidesPerView: parseFloat(slider.getAttribute('data-slide-desktop')),
      }
    },
    on: {
      transitionEnd: function (swiper) {
        const realIndex = swiper.realIndex;
        const activeSlide = originalSlides[realIndex];
        if (!activeSlide) return;

        const currentFilter = activeSlide.querySelector('.product-tabbing__slide')?.dataset.filter;

        tabItems.forEach(tab => {
          tab.classList.remove('is-tab-active');
          if (tab.getAttribute('id') === currentFilter) {
            tab.classList.add('is-tab-active');
          }
        });
      }
    }
  });

  // Click tab → go to corresponding slide
  tabItems.forEach((tabItem) => {
    tabItem.addEventListener('click', () => {
      const filter = tabItem.id;

      let targetIndex = -1;
      originalSlides.forEach((slide, i) => {
        const slideFilter = slide.querySelector('.product-tabbing__slide')?.dataset.filter;
        if (slideFilter === filter) {
          targetIndex = i;
        }
      });

      if (targetIndex !== -1) {
        swiperInstance.slideToLoop(targetIndex);
      }
    });
  });
});
/* end home page product benefits swiper */

function productMatchHeightElement() {
  if ($('.best-product-tabbing .product-box .product-box__detail_top').length > 0) {
    $('.best-product-tabbing .product-box .product-box__detail_top').matchHeight({
      byRow: true,
    });
  }
}

/* start home page product tabbing swiper */

document.querySelectorAll('.product-tabbing:not(.benefites_slider_tabbing)').forEach(tabBox => {
  const tabItems = tabBox.querySelectorAll('.product-tabbing__item');
  const tabCols = tabBox.querySelectorAll('.product-tabbing__col');
  const arrowsContainer = tabBox.querySelector('.js-custom-arrow');
  const prevArrow = tabBox.querySelector('.js-custom-prev-arrow');
  const nextArrow = tabBox.querySelector('.js-custom-next-arrow');
  let activeSwiper = null;

  // Initialize Swipers for each tab
  tabCols.forEach(col => {
    const slider = col.querySelector('.js-tab-slider');
    const swiper = new Swiper(slider, {
      slidesPerView: parseFloat(slider.getAttribute('data-slide-desktop')) || 4.5,
      spaceBetween: 0,
      loop: false,
      allowTouchMove: true,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        0: {
          slidesPerView: parseFloat(slider.getAttribute('data-slide-mobile')) || 1.25,
        },
        768: {
          slidesPerView: parseFloat(slider.getAttribute('data-slide-tab')) || 3.5,
        },
        992: {
          slidesPerView: parseFloat(slider.getAttribute('data-slide-desktop')) || 4.5,
        },
      },
      on: {
        slideChange: function () {
          updateArrowState(this, tabBox);
        },
        slideChangeTransitionEnd: function () {
          productMatchHeightElement();
        }
      }
    });

    slider.swiperInstance = swiper;
  });

  // Show tab by ID
  function showTabById(tabId) {
    tabItems.forEach(item => {
      item.classList.toggle('is-tab-active', item.id === tabId);
    });

    tabCols.forEach(col => {
      const isMatch = col.getAttribute('data-filter') === tabId;
      col.classList.toggle('is-slider-active', isMatch);
      col.style.display = isMatch ? 'block' : 'none';

      if (isMatch) {
        const slider = col.querySelector('.js-tab-slider');
        activeSwiper = slider.swiperInstance;
        if (activeSwiper) {
          activeSwiper.update();
          setTimeout(() => {
            productMatchHeightElement();
            updateArrowState(activeSwiper, tabBox);
          }, 50);
        }

        // Move arrows if not inside .product-tabbing__tab-arrow
        const tabArrow = tabBox.querySelector('.product-tabbing__tab-arrow');
        if (arrowsContainer && !tabArrow.contains(arrowsContainer)) {
          tabArrow.appendChild(arrowsContainer);
        }
      }
    });
  }

  // Setup tab click events
  tabItems.forEach(item => {
    item.addEventListener('click', () => {
      showTabById(item.id);
    });
  });

  // Init default active tab
  const defaultTab = tabItems[0]?.id;
  if (defaultTab) {
    showTabById(defaultTab);
  }

  // Arrow controls
  prevArrow?.addEventListener('click', () => {
    if (activeSwiper) {
      activeSwiper.slidePrev();
      updateArrowState(activeSwiper, tabBox);
    }
  });

  nextArrow?.addEventListener('click', () => {
    if (activeSwiper) {
      activeSwiper.slideNext();
      updateArrowState(activeSwiper, tabBox);
    }
  });

  // Arrow disable/enable logic
  function updateArrowState(swiper, tabBox) {
    const prev = tabBox.querySelector('.js-custom-prev-arrow');
    const next = tabBox.querySelector('.js-custom-next-arrow');

    if (!swiper || !prev || !next) return;

    if (swiper.isBeginning) {
      prev.classList.add('swiper-button-disabled');
    } else {
      prev.classList.remove('swiper-button-disabled');
    }

    if (swiper.isEnd) {
      next.classList.add('swiper-button-disabled');
    } else {
      next.classList.remove('swiper-button-disabled');
    }

    // Hide arrows if all slides fit
    const totalSlides = swiper.slides.length;
    const visibleSlides = swiper.params.slidesPerView;
    const arrowWrapper = tabBox.querySelector('.js-custom-arrow');

    if (totalSlides <= visibleSlides) {
      arrowWrapper.classList.add('is-custom-arrows-hidden');
    } else {
      arrowWrapper.classList.remove('is-custom-arrows-hidden');
    }
  }
});

/* end home page product tabbing swiper */